import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WinLogo from "../../../assets/images/win/logo-win.svg";
import FinalBanner from "../../../assets/images/win/DTCReadyToStart.png";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Endpoints } from "../../../../src/Global/Endpoints";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ErrorModal from "../../Security/ErrorModal";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from 'react-i18next';
import { setFullyVerified } from '../../../Redux/verificationReducer';
import { updateEmail } from '../../../Redux/emailReducer';
import { setRegistrationData } from '../../../Redux/registrationReducer';
import { updateUserData } from '../../../Redux/userReducer';

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const { t } = useTranslation();
  
  const [screen, setScreen] = useState("start");
  const location = useLocation();
  const [ updatedProviderData , setUpdatedProviderData] = useState(location?.state?.updatedProviderData || {});
  const [otherData, setOtherData] = useState(location?.state?.otherData || {});
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [employerName, setEmployerName] = useState("");
  const [errors, setErrors] = useState({ employerName: "" });
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem("accessToken");
  const [modalMessage, setModalMessage] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const fromLoginState = useSelector((state) => state.fromLogin); // select correct slice
  const password = fromLoginState?.password || "";
  const fromLogin = fromLoginState?.fromLogin || false;
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [paymentStatus, setPaymentStatus] = useState(location.state?.paymentStatus);
  const userInfo = useSelector((state) => state.userData);
  debugger;
  const [isSKip, setIsSkip] = useState(false);
  const goBack = () => {
    if (screen === "employer") 
      {setScreen("start");}
    else if (screen === "ready")
      { setScreen("start");}
    else if (fromLogin)
       {
        dispatch({ type: 'CLEAR_PASSWORD' });
        navigate("/login");
      }
    else {
      navigate("/services", { state: { updatedProviderData: updatedProviderData, otherData: otherData } });
    }
  };
 useEffect(() => {
  if (paymentStatus === "failed") {
    setScreen("start");
    setShowPaymentModal(true);
    setModalMessage("Payment failed. Please try again.");
    // 🔥 IMPORTANT: clear paymentStatus but preserve updatedProviderData and otherData
    navigate(location.pathname, {
      replace: true,
      state: {
        updatedProviderData,
        otherData
      }
    });
  } else if (paymentStatus === "success") {
    setScreen("employer");
    setShowPaymentModal(true);
    setModalMessage("Payment successful!");
    navigate(location.pathname, {
      replace: true,
      state: {
        updatedProviderData,
        otherData
      }
    });
  }
}, [paymentStatus, navigate, location.pathname, updatedProviderData, otherData]);


  const getPaymentLink = async () => {
    debugger
    try {
      const params = {
        EmailID: updatedProviderData?.EmailID || userInfo.userData.EmailID,
        Amount: updatedProviderData?.Amount || userInfo.userData.UKDTCAmount,
      };
      const response = await axios.post(Endpoints.GetUKDTCPaymentLink,null,
        {
          params: { _Params: JSON.stringify(params) },
        }
      );
      if (response.status === 200) {
        const paymentLink = response.data;
        debugger
        // Instead of redirect, navigate to PaymentIframe and pass the link, updatedProviderData, and otherData
        navigate("/payment-iframe", { state: { paymentLink, updatedProviderData, otherData } });
      }
    } catch (err) {
      console.error('Error loading UKDTC service amounts:', err);
      toast.error("Failed to retrieve payment link.");
    }};
    
    useEffect(() => {
      if (isSuccessful) {
        setScreen("employer");
      }
    }, [isSuccessful]);

    const UpdateUKDTCDetail = async () => {
      debugger
      try {
        const params = {
          emailID: updatedProviderData?.EmailID || userInfo.userData.EmailID,
          amount: otherData?.amount || userInfo.userData.UKDTCAmount,
          service: otherData?.referralSource || userInfo.userData.UKDTCService,
          employername: isSKip ? "" : employerName ,
        };
        const response = await axios.post(Endpoints.UpdateUKDTCDetails,
          null,
          {
            params: { _Params: JSON.stringify(params) },
          }
        );
        if (response.status === 200) {
          //  await CreateAccount(true);
        }
      } catch (err) {
        console.error('Error loading UKDTC service amounts:', err);
      }
    };
 
    const getTokenId = async () => {
      const devicetype = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
      // Robustly get credentials from all possible sources
      const pwd = updatedProviderData?.PWD ||  password || "";
      const email = updatedProviderData?.EmailID || userInfo.userData?.EmailID || "";
      if (!pwd || !email) {
        toast.error("Missing credentials for token generation.");
        return null;
      }
      try {
        const response = await axios.post(
          Endpoints.GET_Token,
          `Password=${encodeURIComponent(pwd)}&UserName=${encodeURIComponent(email)}&DeviceType=${encodeURIComponent(devicetype)}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            }
          }
        );
        if (response.data?.Token?.TokenId) {
          const token = response.data.Token.TokenId;
          // Store token in cookies and local storage
          cookies.set('AccessToken', token, { path: '/' });
          localStorage.setItem('AccessToken', token);
          return token;
        }
      } catch (error) {
        toast.error(t("toastmessage"));
        return null;
      }
    };

  const CreateAccount = async (isPaymentDone) => {
    if (Object.keys(updatedProviderData).length > 0) {
    updatedProviderData.Contract = otherData?.referralSource ==="Broadstone"? "Broadstone-Global-WINfant Pathways" : otherData?.referralSource;
    updatedProviderData.WhyHere = "I want family-building support";
    var paramsObject ={
      ...updatedProviderData,
          EmployeeID: "",
          EmployeeFirstName: "",
          EmployeeLastName: "",
          RelationshiptoEmployee: "",
          IsHealthProfileCompleted: paymentStatus==="success" ? 1:0
    }
    console.log("Updated Form Data with Access Code:", updatedProviderData);      
    }
    else
    {
 var paramsObject ={
      "FirstName": userInfo.userData.FirstName ||"",
      "LastName": userInfo.userData.LastName ||"",
      "PreferredName": userInfo.userData.PreferredName ||"",
      "EmailID": userInfo.userData.EmailID,
      "PWD": password || userInfo.userData.PWD,
      "ConfirmPassword": password || userInfo.userData.PWD ||"",
      "AgreeTerms": true,
      "Country": userInfo.userData.Country ||"",
      "ZipCode": userInfo.userData.ZipCode ||"",
      "Language": userInfo.userData.Language ||"",
      "Ethnicity": userInfo.userData.Ethnicity ||"",
      "PhoneNo": userInfo.userData.MobileNumber ||"",
      "DOB": userInfo.userData.DOB ||"",
      "TextNotificationStatus": userInfo.userData.TextNotificationStatus || false,
      "Version": "",
      "AppLanguage": "",
      "DeviceType": "",
      "Company": "",
      "MemberID": "",
      "WhyHere": "I want family-building support",
      "WINBenefits": "",
      "Promocode": "",
      "Pronouns": "",
      "UpdateFlag": "",
      "JourneyStatus": "",
      "HealthPlanId": "",
      "RelationshipStatus": "",
      "BenefitProvider": "",
      "SubscriberID": "",
      "Gender": "",
      "Contract": userInfo.userData.UKDTCService ==="Broadstone"? "Broadstone-Global-WINfant Pathways" : "WINFertilityUKDTC",
      "SecureCode": "",
      "Goal": "",
      "CountryCode": "",
      "EmployeeID": "",
      "EmployeeFirstName": "",
      "EmployeeLastName": "",
      "RelationshiptoEmployee": "",
      "IsHealthProfileCompleted": paymentStatus==="success" ? 1:0
    }
    
    console.log("Updated Form Data with Access Code:", userInfo.userData);
    }
    // implement create account like in healthprofile_multistage page --> the method has get token id call too
    
    setLoading(true);
    try {
      setIsSubmitting(true);
      setLoading(true);
      console.log("Payload:", `_Params=${encodeURIComponent(JSON.stringify(paramsObject))}`);

 const response = await axios.post(
          Endpoints.CreateAccount,
          `_Params=${encodeURIComponent(JSON.stringify(paramsObject))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
             // "Authorization": `Bearer ${token}`,
            }
          }
        );
        if(response.status === 200){
          UpdateUKDTCDetail();
        }
      if (response.data.Result === 2) {
        if (!isPaymentDone) {
         dispatch({ type: 'CLEAR_PASSWORD' });
         navigate("/login");
        } else {
          let token = await getTokenId();
          console.log("Token after validation:", token);
          debugger
          if (token) {
            console.log("Obtained Token:", token);
            cookies.set('AccessToken', token, { path: '/' });
            localStorage.setItem('AccessToken', token);

            // Initialize session expiration
            const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
            localStorage.setItem('sessionExpiration', expirationTime.toString());
            localStorage.removeItem('sessionExpired'); // Clear any existing expired flag

            // Update Redux state
            dispatch({ type: 'LOGIN_SUCCESS', payload: token });
              dispatch(setFullyVerified());
               dispatch(setRegistrationData(response.data));
            dispatch(updateUserData(response.data));
             dispatch(updateEmail(response.data.EmailID));
          toast.success(t('profilesavedsucessfully'), { autoClose: 5000 });
          dispatch({ type: 'CLEAR_PASSWORD' });
          navigate("/home");
          }else{
            toast.error("Failed to create account");
          }
        }
      }else if(response.data.Result === 0){
        debugger;
        console.error("Account creation failed with response:", response.data);
        dispatch({ type: 'CLEAR_PASSWORD' });
        navigate("/login"); // Uncommenting the navigation to login on failure
      }else{
        setModalMessage(response.data.Message || "An unexpected error occurred.");
      }
                   } catch (error) {
                     console.error("API Error:", error);
                     navigate("/login");
                   } finally {
                     setIsSubmitting(false);
                     setLoading(false);
                   }
  };

    const handleSubmit = async() => {
      if (!employerName?.trim()) {
        setErrors((prev) => ({ ...prev, employerName: "Employer name is required" }));
        return;
      }
      await CreateAccount(true);
     }

  return (
    <>
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            <img src={WinLogo} alt="WIN Logo" className="logo brand-logo" />
          </a>
        </nav>
      </header>

      <div className="paymentstep-page-wrapper">
        <div className="paymentstep-centered-container">
          <div className="registration-block-main patient-consent-screen paymentstep-wrapper">

            {/* Back Button */}
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
              {screen !== "employer" || paymentStatus !== "success" ? (
                <button className="win-back-btn" onClick={goBack}>
                  <span>
                    <i className="bi bi-chevron-left"></i> Back
                  </span>
                </button>
              ) : ""}
            </div>

            {/* Banner – Only for screens 1 & 2 */}
            {screen !== "ready" && (
              <div className="final-banner-wrapper mt-5">
                <img src={FinalBanner} alt="Banner" className="final-banner-img" />
              </div>
            )}

            {/* ---------------------------------------------------------------------- */}
            {/* SCREEN 1 — Ready to get started?                                      */}
            {/* ---------------------------------------------------------------------- */}
            {screen === "start" && (
              <div className="registration-form-main mt-2 paymentstep-form">
                <div className="registration-form payment-wrapper">
                  <div className="registration-process-form-wrapper">

                    <h2 className="page-heading-primary mt-4">
                      Ready to get started?
                    </h2>

                    <p className="text-mute mt-3">
                      We’re here to support you with compassionate support,
                      expert guidance, and trusted resources.
                    </p>

                    <p className="text-mute mt-3">
                      If you have any questions, 
                      our team is here to help—call <span className="text-primary">0800-654-6303</span>, Monday-Friday, 9am-5pm GMT.
                    </p>

                    <p className="text-mute mt-3">
                      Begin your fertility journey with WIN by proceeding with payment below.
                    </p>

                    <div className="mt-4 d-flex">
                      <button
                        className="win-btn-primaryy w-100"
                        onClick={() => { setScreen("employer");
                          getPaymentLink();
                         }}
                      >
                        Continue to payment
                      </button>
                    </div>

                    <div className="mt-3 d-flex">
                      <button
                        className="win-btn-secondaryy w-100"
                        onClick={() =>{setScreen("ready");}}
                      >
                        I’ll come back when I’m ready
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            )}

            {/* ---------------------------------------------------------------------- */}
            {/* SCREEN 2 — Help us bring WIN to your workplace                         */}
            {/* ---------------------------------------------------------------------- */}
            {screen === "employer" && (

              <div className="registration-form-main mt-2 paymentstep-form">
                <div className="registration-form payment-wrapper">
                  <div className="registration-process-form-wrapper">

                    <h2 className="page-heading-primary mt-4">
                      Help us bring WIN to your workplace
                    </h2>
                   { ((!fromLogin && otherData?.referralSource !== "Broadstone")
                    || (fromLogin && userInfo?.userData?.UKDTCService !== "Broadstone")) ?(
                  <>
                    <p className="text-mute mt-3">
                      Would you like us to reach out to your employer to explore
                      expanding their benefit coverage through WIN? Your name and
                      personal information will stay completely anonymous.
                    </p>

                    <p className="text-mute mt-3">
                      If yes, please share your employer’s name:
                    </p>
                    </>):(
                      <>
                      <p>To explore potential Benefit coverage through WIN, and help reduce out-of-pocket fertility costs, we need to confirm your employer.</p>
                     <p>We will never share your name or personal information.</p>
                      </>
                    )}
                    <div className="d-flex">
                      <input
                        type="text"
                        placeholder="Employer name"
                        className="win-form-control-p mt-3"
                        onChange={(e) => { 
                          setEmployerName(e.target.value);
                          if (e.target.value?.trim()) {
                            setErrors((prev) => ({ ...prev, employerName: "" }));
                          }
                        }}
                      />
                    </div>
                    {errors.employerName && (
                      <div className="text-danger small mt-1">{errors.employerName}</div>
                    )}

                    <div className="mt-3 d-flex">
                      <button className="win-btn-primaryy w-100" onClick={handleSubmit}>
                        Submit
                      </button>
                    </div>

                    {((!fromLogin && otherData?.referralSource !== "Broadstone")
                     || (fromLogin && userInfo?.userData?.UKDTCService !== "Broadstone")) && <div className="mt-3 d-flex">
                      <button
                        className="win-btn-secondaryy w-100"
                        onClick={() => { setErrors((prev) => ({ ...prev, employerName: "" }));
                        setIsSkip(true); CreateAccount(true); }}
                      >
                        Skip
                      </button>
                    </div>}

                  </div>
                </div>
              </div>
            )}

            {/* ---------------------------------------------------------------------- */}
            {/* SCREEN 3 — When you're ready, WIN will be here                        */}
            {/* ---------------------------------------------------------------------- */}
            {screen === "ready" && (
              <div className="registration-form-main mt-4 paymentstep-form">
                <div className="registration-form payment-wrapper">
                  <div className="registration-process-form-wrapper">

                    <h2 className="page-heading-primary mt-3">
                    
                      When <br /> you’re ready, <br />
                      <span style={{ color: "#E5008A" }}>WIN will <br />be here.</span>
                    </h2>

                    <p className="text-mute mt-4">
                      We understand that starting your fertility journey is a big decision.
                      Whenever you're ready, we’ll be here with compassionate support,
                      expert guidance, and trusted resources.
                    </p>

                    <p className="text-mute mt-3">
                      You can return at any time to complete your account setup and begin
                      your WIN journey.
                    </p>

                    <div className="mt-4 d-flex">
                      <button onClick={()=>{ CreateAccount(false); 
                         }} className="win-btn-primaryy w-100">
                        Okay
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
        <ErrorModal show={showPaymentModal} message={modalMessage} onClose={() => {setShowPaymentModal(false); }} closeButton={true}/>

      </div>
    </>
  );
};

export default Payment;
